// @flow
import React from 'react'

const DumbBells = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="13" viewBox="0 0 23 13">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C" strokeLinecap="square">
        <path d="M5.5.5v12M2.5 2.5v8M17.5.5v12M20.5 2.5v8M5.5 6.5h12M2.5 6.5h-2M20.5 6.5h2" />
      </g>
    </svg>
  )
}

export default DumbBells



// WEBPACK FOOTER //
// ./src/components/Icons/DumbBells.js